import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    apps: null,
    tokenIsSet: false,
    selectedAppId: null,
    error: false
};

export default createSlice({
    name: 'applications',
    initialState,
    reducers: {
        setApps: (state, action) => {
            state.apps = action.payload;
            return state;
        },
        setSelectedApplication: (state, action) => {
            state.selectedAppId = action.payload;
            return state;
        },
        setTokenStatus: (state, action) => {
            state.tokenIsSet = !!action.payload
            return state;
        },
        setErrorFlag: (state) => {
            state.error = true;
            return state;
        },
        resetApps: state => {
            return initialState;
        }
    },
});